import { Chip, Skeleton, Typography } from "@mui/material";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const RecentSearches = ({ showDetails = (data: any) => {} }) => {
  const { t } = useTranslation();

  const { recentJobSearchs, isPrePopulatedJobSearchesLoading } = useSelector(
    (state: any) => {
      return state.jobpricing;
    }
  );

  return (
    <div className={styles.searchHistory}>
      <Typography variant="h6" className={styles.subtext}>
        {t("pa.sjpr.recentSearches")}
      </Typography>

      <div className={styles.searchChipsBlock}>
        {isPrePopulatedJobSearchesLoading ? (
          [1, 2, 3, 4].map((value: number, index: number) => (
            <Skeleton
              key={index}
              variant="rounded"
              width={80}
              height={30}
              sx={{ borderRadius: 50, marginLeft: 2 }}
            />
          ))
        ) : (
          <>
            {recentJobSearchs?.length === 0 && t("pa.noDataFound")}
            {recentJobSearchs?.map((item: any, index: number) => {
              return (
                <Chip
                  key={"RecentSearches" + index}
                  className={styles.searchChip}
                  label={item?.searchTerm || ""}
                  variant="outlined"
                  onClick={() => {
                    showDetails(item);
                  }}
                  clickable
                />
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export const PopularSearches = ({ showDetails = (data: any) => {} }) => {
  const { t } = useTranslation();
  const { popularJobSearchs, isPrePopulatedJobSearchesLoading } = useSelector(
    (state: any) => {
      return state.jobpricing;
    }
  );
  return (
    <div className={`${styles.searchHistory} ${styles.popularSearches}`}>
      <Typography variant="h6" className={styles.subtext}>
        {t("pa.sjpr.popularSearches")}
      </Typography>

      <div className={styles.searchChipsBlock}>
        {isPrePopulatedJobSearchesLoading ? (
          [1, 2, 3, 4].map((value: number, index: number) => (
            <Skeleton
              key={index}
              variant="rounded"
              width={80}
              height={30}
              sx={{ borderRadius: 50, marginLeft: 2 }}
            />
          ))
        ) : (
          <>
            {popularJobSearchs?.length === 0 && t("pa.noDataFound")}
            {popularJobSearchs?.map((item: any, index: number) => {
              return (
                <Chip
                  key={"PopularSearches" + index}
                  className={styles.searchChip}
                  label={item?.searchTerm || ""}
                  variant="outlined"
                  onClick={() => {
                    showDetails(item);
                  }}
                  clickable
                />
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};
